export enum SIZES {
  'small' = 4,
  'medium' = 8,
  'large' = 12,
}
